import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { convertDateStringToISO } from 'app/utilities/dateUtils';
import { Mesages } from './constant';
import { ColumnHtmlWithIcon } from '../SelfCareProductsAndServicesBlock/Shared/sharedHtmlComponents';

export const getInitialData = createAsyncThunk(
  'dwhReportManagement/GetInitialData',
  async (data, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const orgId = state.portalsBlock.selectedHetPayId;
      await Promise.all([
        thunkAPI.dispatch(getBusinessReportCoreData({orgId: orgId})),
        thunkAPI.dispatch(getSelfServiceReports({...state.dwhReportManagement.reportFilter, pageNo: 1, orgId: orgId , sortConfig: state.dwhReportManagement.sortConfig})),
      ]);
      return {
        data: '',
        error: false,
      };
    }
    catch (error) {
      return {
        data: '',
        error: true,
      };
    }
  },
);


export const getSelfServiceReports = createAsyncThunk(
  'dwhReportManagement/GetReportsByFilter',
  async (data, thunkAPI) => {
    try {
      var filter = {
        startDate:convertDateStringToISO(data.startDate ,false),
        endDate:convertDateStringToISO(data.endDate ,true ),
        orgId:data.orgId,
        pageNo:data.pageNo ?? 1,
        subAreas:data.subAreas,
        reportScoppe:data.report_scoppe,//my/all
        type: 'CELLCOM_SITE',
        sortConfig: data.sortConfig,
      };
      const result = await ProviderManager.getProviderData('GetReportsByFilter', filter);
      return { 
        data: result.Body,
        error: false,
      };
    } catch (error) {
      return {
        data: '',
        error: true,
      };
    }
  },
);


export const getBusinessReportCoreData = createAsyncThunk(
  'dwhReportManagement/getBusinessReportCoreData',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      var type ='CELLCOM_SITE';
      const result = await ProviderManager.getProviderData('GetBusinessReportCoreData', [type , data.orgId]);
      thunkAPI.dispatch(hideAppLoader());
      return { 
        data: result.Body,
        error: false,
      };
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return {
        data: '',
        error: true,
      };
    }
  },
);


const initialState = {
  loading: false,
  error: null,
  data: null,
  reports: [],
  mappingReports: [],
  orgContacts: {},
  totalCount: 0,
  minDate: null,
  reportFilter: {
    startDate: null,
    endDate: null,
    orgId: null,
    pageNo: 1,
    subAreas: [],
  },
  sortConfig: {},
  isLoading: false,
  filterOptionsLoaded: false,
};

const dwhReportManagementSlice = createSlice({
  name: 'dwhReportManagement',
  initialState,
  reducers: {
    // add your synchronous reducers here 
      setReportFilter: (state, action) => {
        if(!action.payload){
          state.reportFilter = initialState.reportFilter;
          return;
        }
        state.reportFilter = {...state.reportFilter, ...action.payload};
      },
      setMappingReports: (state, action) => {
        state.mappingReports = action.payload;
      },
      setSortConfig: (state, action) => {
        state.sortConfig = { ...action.payload};
      },
      saveToHistory: (state, action) => {
        return state;
      },
      clearHistory: (state, action) => {
        return initialState;
      },
  },
  extraReducers: {

    [getSelfServiceReports.fulfilled]: (state, action) => {
      var res = action.payload.data;
      if(res){
        if(res.businessReportItems?.length === 0){
          if (JSON.stringify(state.reportFilter) === JSON.stringify(initialState.reportFilter)) {
            state.error = Mesages.NoResultsFound;
          }
          else{
            state.error = Mesages.NoResultsFoundForFilter;
          }
        }else{
          state.error = null;
            if(state.reportFilter.pageNo === 1){
              state.reports = res.businessReportItems;
            }else{
              state.reports = [...state.reports, ...res.businessReportItems];
            }
            state.totalCount = res.totalCount;
            state.minDate = res.minCreatedDate || state.minDate;
          }
        }
        state.isLoading = false;
    } ,
    [getSelfServiceReports.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getSelfServiceReports.rejected]: (state, action) => {
      state.isLoading = false;
    },

    [getBusinessReportCoreData.fulfilled]: (state, action) => {
      var res = action.payload.data;
      if(res){
          state.mappingReports = res.reportsTypes;
          state.orgContacts = res.contactsByOrgId;
          state.filterOptionsLoaded = true;
      }
  },
  },
});

export const { setReportFilter , saveToHistory , setSortConfig , setMappingReports } = dwhReportManagementSlice.actions;

export default dwhReportManagementSlice.reducer;
